export const terminationReasonOptions = Object.freeze([
  {
    value: 'Mutuo acuerdo de las partes',
    label: 'Mutuo acuerdo de las partes'
  },
  { value: 'Término de obra o servicio', label: 'Término de obra o servicio' },
  { value: 'Renuncia del trabajador', label: 'Renuncia del trabajador' },
  {
    value: 'Vencimiento del plazo convenido en el contrato',
    label: 'Vencimiento del plazo convenido en el contrato'
  },
  {
    value: 'Traslado a faena de otro Contratista',
    label: 'Traslado a faena de otro Contratista'
  },
  {
    value: 'No concurrencia del trabajador a sus labores sin causa justificada',
    label: 'No concurrencia del trabajador a sus labores sin causa justificada'
  },
  {
    value: 'Por conductas indebidas de carácter grave, debidamente comprobadas',
    label: 'Por conductas indebidas de carácter grave, debidamente comprobadas'
  },
  {
    value: 'Abandono del trabajo por parte del trabajador',
    label: 'Abandono del trabajo por parte del trabajador'
  },
  {
    value: 'Actos, omisiones o imprudencias temerarias',
    label: 'Actos, omisiones o imprudencias temerarias'
  },
  {
    value: 'Perjuicio material causado intencionalmente',
    label: 'Perjuicio material causado intencionalmente'
  },
  {
    value: 'Incumplimiento grave de las obligaciones que impone el contrato',
    label: 'Incumplimiento grave de las obligaciones que impone el contrato'
  },
  {
    value:
      'Por negociaciones que están prohibidas por escrito en el respectivo contrato',
    label:
      'Por negociaciones que están prohibidas por escrito en el respectivo contrato'
  },
  { value: 'Necesidades de la empresa', label: 'Necesidades de la empresa' },
  {
    value: 'Caso fortuito o fuerza mayor',
    label: 'Caso fortuito o fuerza mayor'
  },
  {
    value: 'Liquidación de bienes del empleador',
    label: 'Liquidación de bienes del empleador'
  },
  { value: 'Muerte del trabajador', label: 'Muerte del trabajador' }
])
